/**
 * @generated SignedSource<<6f0d1b30a92ff0a8cacb1f15fdda38b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type RovoCleanUpTeamsNudgeQuery$variables = {
  cloudId?: string | null;
  isCleanUpTeamsRovoSkillEnabled: boolean;
  organisationId: string;
  userTeamQuery: string;
};
export type RovoCleanUpTeamsNudgeQuery$data = {
  readonly userTeams?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type RovoCleanUpTeamsNudgeQuery = {
  response: RovoCleanUpTeamsNudgeQuery$data;
  variables: RovoCleanUpTeamsNudgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCleanUpTeamsRovoSkillEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userTeamQuery"
},
v4 = [
  {
    "condition": "isCleanUpTeamsRovoSkillEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "userTeams",
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          },
          {
            "kind": "Variable",
            "name": "organisationId",
            "variableName": "organisationId"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "userTeamQuery"
          }
        ],
        "concreteType": "TeamSearchResponseConnection",
        "kind": "LinkedField",
        "name": "teamsTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RovoCleanUpTeamsNudgeQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RovoCleanUpTeamsNudgeQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e0b3c71a904a6d29e04660a757ef5e47",
    "id": null,
    "metadata": {},
    "name": "RovoCleanUpTeamsNudgeQuery",
    "operationKind": "query",
    "text": "query RovoCleanUpTeamsNudgeQuery(\n  $organisationId: String!\n  $cloudId: String\n  $userTeamQuery: String!\n  $isCleanUpTeamsRovoSkillEnabled: Boolean!\n) {\n  userTeams: teamsTql(q: $userTeamQuery, first: 5, organisationId: $organisationId, cloudId: $cloudId) @include(if: $isCleanUpTeamsRovoSkillEnabled) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df2d9856314c97d9c7d498e1d64bc284";

export default node;
